import gql from 'graphql-tag';

export const ACTIVITY_STREAM_QUERY = gql`
query activityStream($after: NexusId, $before: NexusId, $first: Int, $last: Int, $userId: NexusId) {
  activityStream(after: $after, before: $before, first: $first, last: $last, userId: $userId) {
    activities {
      assocId
      assocType
      body
      id
      insertedAt
      user {
        id
        username
        insertedAt
        avatar {
          thumb
          full
        }
      }
    }
    pageInfo {
      endId
      hasNextPage
      hasPreviousPage
      startId
    }
  }
}
`;
